app.service('front', function () {

    function getPage() {
        return $('body').attr('id');
    }

    return {
        getPage
    }
})